import api from '../requests';
import moment from 'moment';
import { filterString, toUpper, isEmptyArray } from '../../util/functions';
import { TRADE_CATEGORY } from '../../util/tradeFilterConstants';
const FileDownload = require('js-file-download');
import queryString from 'query-string';

export function getTradeQueryString (params) {
  let queryParams = {
    symbol: toUpper(params.symbol),
    startDate: params.startDate,
    endDate: params.endDate,
    startTime: params.startTime,
    endTime: params.endTime,
    mpid: toUpper(params.mpid),
    side: filterString(params.side),
    venue: filterString(params.venue),
    orderCapacity: params.orderCapacity,
    clientOrderId: params.clientOrderId,
    execId: params.execId,
    liquidityIndicator: params.liquidityIndicator,
    category: filterString(params.category),
    minSize: params.minSize,
    maxSize: params.maxSize,
    sortDir: params.sortDir,
    sortOn: params.sortOn
  };
  return queryString.stringify(queryParams);
}

export async function getTrades (params, sort) {
  if (isEmptyArray(params.category)) {
    params.category = TRADE_CATEGORY;
  }
  let tradeQueryObject = { ...params, ...sort };
  let query = getTradeQueryString(tradeQueryObject);

  const response = await api.request({
    method: 'get',
    url: `/internal/trade-data?${query}`
  });
  return response.data;
}

export async function downloadTrades (params) {
  if (isEmptyArray(params.category)) {
    params.category = TRADE_CATEGORY;
  }
  let query = getTradeQueryString(params);

  const response = await api.request({
    method: 'get',
    responseType: 'blob',
    url: `/internal/trade-data/download?${query}`
  });

  FileDownload(response.data, `ECN_Trades-${moment().format('MM/DD/YYYY')}.xlsx`);
}

export async function getTradeFixMsgs (params) {
  //  console.log('param', params);

  const response = await api.request({
    method: 'get',
    url: `/internal/trade-data/fix-msg`,
    params: {
      tradeDate: params.tradeDate,
      exchangeRef: params.exchangeRef,
      linkId: params.linkId
    }
  });
  return response.data;
}
